kv.controller('addNotesCtrl', function ($uibModalInstance, params, resource, $scope, $injector) {
    let vm = new modalCtrl($uibModalInstance, $injector, 'comment', 'comment_id', $scope, params);
    vm.modal.rendered.then(() => {
        if (!vm.dataHasLoaded) KApp.block('.modal-content');
    });
    vm.data = {};
    vm.dataHasLoaded = false;
    vm.isNewRecord = true;
    vm.data.invoice_id = angular.copy(params.invoice_id);
    vm.dataHasLoaded = true;

    vm.entity = 'collection_logs';
    var REST = resource.init(vm.entity);
    vm.data.comment = '';

    /**
     * ck editor config
     */
    vm.ckeditor = {
        height: 300,
        toolbarGroups: [
            {name: 'editing'},
            {name: 'basicstyles', groups: ['basicstyles'] },
            // { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
            // {name: 'font'},
            // {name: 'styles'},
            {name: 'colors'}
        ],
        removeButtons: 'Subscript,Superscript,RemoveFormat,Strike,Blockquote'
    };

    vm.saveNote = function () {
        let postData = angular.copy(vm.data);
        REST.post({
            url: 'invoice/' + vm.data.invoice_id + '/collection/actions/new_comment',
            params: {
                comment: postData
            }
        }).then(function (response) {
            if(response.status === 'success'){
                toastr.success(response.message);
            }else{
                toastr.error('Error creating note');
            }
            vm.close();
        });
    };

    return vm;
});
